import { render, staticRenderFns } from "./StackRouterView.vue?vue&type=template&id=2efb8507&scoped=true"
import script from "./StackRouterView.vue?vue&type=script&lang=js"
export * from "./StackRouterView.vue?vue&type=script&lang=js"
import style0 from "./StackRouterView.vue?vue&type=style&index=0&id=2efb8507&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efb8507",
  null
  
)

export default component.exports